export default __webpack_public_path__ + "static/media/tarjeta-de-debito.1d53fd00.svg";